import React, { useState } from "react";
import { FaCar, FaRoute, FaShieldAlt, FaHeadset } from "react-icons/fa";
import driver from "../../assets/img/driver.jpg";

const Driver = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    "What are the requirements for drivers?",
    "I've changed my phone number, now I can't log into my account",
    "How do I change my profile photo in CabandGo?",
    "How do I delete my CabandGo account?",
  ];

  const answers = [
    "Valid driver's license, vehicle registration, insurance, and background check are required.",
    "Go to Settings → Account → Update Phone Number and verify with OTP.",
    "Open your profile → Tap the camera icon → Select or take a new photo.",
    "Contact support at support@cabandgo.com to permanently delete your account.",
  ];

  return (
    <div
      className="driver-page"
      style={{
        backgroundColor: "#fffdf5",
        minHeight: "100vh",
        padding: "60px 20px",
      }}
    >
      <style jsx>{`
        .title {
          font-size: 48px;
          font-weight: 900;
          text-align: center;
          color: #000;
          margin-bottom: 20px;
        }
        .highlight {
          color: #098535;
          background-color: #fede33;
          padding: 4px 12px;
          border-radius: 8px;
          display: inline-block;
        }

        /* Updated: Beautiful, justified, friendly & readable hero write-up */
        .hero-writeup {
          font-size: 22px;
          font-weight: 600;
          color: #000000;
          max-width: 960px;
          margin: 0 auto 80px;
          line-height: 1.65;
          text-align: justify;
          text-justify: inter-word;
          padding: 0 20px;
        }
        .hero-writeup strong {
          color: #000;
          font-weight: 800;
        }
        .hero-writeup .glow {
          color: #fede33;
          font-weight: 900;
          font-size: 24px;
          text-shadow: 0 0 15px rgba(254,222,51,0.5);
        }

        .benefits-card {
          background: white;
          border-radius: 24px;
          padding: 50px 40px;
          box-shadow: 0 10px 40px rgba(0,0,0,0.08);
          max-width: 1100px;
          margin: 0 auto 80px;
          position: relative;
          overflow: hidden;
        }
        .driver-img {
          width: 380px;
          border-radius: 50%;
          border: 12px solid #fede33;
          box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        }
        .heart-shape {
          position: absolute;
          top: -80px;
          left: -80px;
          width: 400px;
          height: 400px;
          background: #098535;
          border-radius: 50% 50% 50% 0;
          transform: rotate(-45deg);
          z-index: 0;
        }
        .benefit-item {
          display: flex;
          align-items: flex-start;
          gap: 20px;
          margin-bottom: 32px;
          position: relative;
          z-index: 1;
        }
        .icon-circle {
          width: 56px;
          height: 56px;
          background: #fede33;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          color: #098535;
          font-size: 26px;
        }
        .benefit-title {
          font-size: 20px;
          font-weight: 700;
          color: #000000;
          margin: 0 0 6px 0;
        }
        .benefit-desc {
          color: #444;
          line-height: 1.6;
          margin: 0;
        }
        .faq-title {
          font-size: 42px;
          font-weight: 900;
          text-align: center;
          color: #000;
          margin: 100px 0 50px;
        }
        .faq-item {
          background: white;
          border-radius: 16px;
          padding: 20px 24px;
          margin-bottom: 16px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.06);
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .faq-item:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(0,0,0,0.1);
        }
        .faq-question {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 600;
          color: #333;
        }
        .plus {
          width: 32px;
          height: 32px;
          background: #098535;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: bold;
          flex-shrink: 0;
          transition: transform 0.3s ease;
        }
        .faq-item.open .plus {
          transform: rotate( Verride(45deg);
        }
        .faq-answer {
          margin-top: 16px;
          color: #555;
          line-height: 1.7;
          padding-left: 76px;
        }

        @media (max-width: 992px) {
          .title, .faq-title { font-size: 36px; }
          .hero-writeup {
            font-size: 19px;
            line-height: 1.7;
            padding: 0 15px;
            margin-bottom: 70px;
          }
          .glow { font-size: 22px; }
          .benefits-card { padding: 40px 20px; text-align: center; }
          .driver-img { width: 280px; margin: 0 auto 40px; }
          .heart-shape {
            width: 300px;
            height: 300px;
            top: -40px;
            left: 50%;
            transform: translateX(-50%) rotate(-45deg);
          }
          .benefit-item { flex-direction: column; text-align: center; }
          .icon-circle { margin: 0 auto 16px; }
        }

        @media (max-width: 576px) {
          .hero-writeup { font-size: 18px; }
          .glow { font-size: 20px; }
        }
      `}</style>

      {/* Hero Section */}
      <h1 className="title">
        Why drivers <span className="highlight">choose us</span>
      </h1>

      {/* Improved & Justified Hero Write-up */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <p className="hero-writeup">
              Sign up today and start earning <strong>on your terms</strong> —
              no boss, no fixed hours, just{" "}
              <span className="">pure freedom</span>.<br />
              You decide when to drive, which rides to accept, and how much you
              earn. We handle the matching, payments, and support — so you can
              focus on driving and living life your way.
              <strong>Your car. Your schedule. Your income.</strong>
            </p>
          </div>
        </div>
      </div>

      {/* Benefits Card */}
      <div className="benefits-card">
        <div className="heart-shape"></div>

        <div className="row align-items-center">
          <div className="col-lg-5 text-center position-relative">
            <img
              src={driver}
              alt="Happy CabandGo Driver"
              className="driver-img"
            />
          </div>

          <div className="col-lg-7">
            <div className="benefit-item">
              <div className="icon-circle">
                <FaCar />
              </div>
              <div>
                <h3 className="benefit-title">Pricing control</h3>
                <p className="benefit-desc">
                  Offer your own price if you don’t like the passenger’s initial
                  offer
                </p>
              </div>
            </div>

            <div className="benefit-item">
              <div className="icon-circle">
                <FaRoute />
              </div>
              <div>
                <h3 className="benefit-title">Route visibility</h3>
                <p className="benefit-desc">
                  See the route before you accept the order
                </p>
              </div>
            </div>

            <div className="benefit-item">
              <div className="icon-circle">
                <FaShieldAlt />
              </div>
              <div>
                <h3 className="benefit-title">Freedom to choose</h3>
                <p className="benefit-desc">
                  Skip as many ride requests as you like, with zero penalties.
                  Experience the freedom of a flexible work schedule
                </p>
              </div>
            </div>

            <div className="benefit-item">
              <div className="icon-circle">
                <FaHeadset />
              </div>
              <div>
                <h3 className="benefit-title">Safety and support</h3>
                <p className="benefit-desc">
                  24/7 in-app support, plus safety features and emergency calls
                  during your rides
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <h2 className="faq-title">
        Frequently asked <span className="highlight">questions</span>
      </h2>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            {faqs.map((question, index) => (
              <div
                key={index}
                className={`faq-item ${openIndex === index ? "open" : ""}`}
                onClick={() => toggleFAQ(index)}
              >
                <div className="faq-question">
                  <span>{question}</span>
                  <div className="plus">+</div>
                </div>
                {openIndex === index && (
                  <div className="faq-answer">{answers[index]}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Driver;
